import { useState, useEffect } from "react";
import { useRCSReportSmryByPartners } from "./useSmryPartner";
import { useFormSmryPartner } from "./useFormSmryPartner";
import { errorLabels } from "../../../../../utils/helpers";
import { ErrorMessage } from "../../../../../utils/toastify";
export const useRCSSmryReportByPartners = () => {
  const { mutate, isPending, data = [] } = useRCSReportSmryByPartners();
  const [reset, setReset] = useState(false);
  const formik = useFormSmryPartner({
    onSubmit: mutate,
  });

  const _validate = async () => {
    try {
      const isValid = await formik.validateForm();
      const errors = errorLabels(isValid);

      if (Object.keys(isValid).length !== 0) {
        throw new Error(`Campos inválidos: ${errors}`);
      }
      await formik.submitForm();
    } catch (error) {
      ErrorMessage(error.message);
    }
  };

  const handleReset = () => {
    formik.resetForm();
    setReset(true);
  };

  useEffect(() => {
    if (reset) {
      setReset(false);
    }
  }, [reset]);

  return {
    formik,
    isLoading: isPending,
    data,
    reset,
    handleReset,
    _validate,
  };
};
